import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
    DRIPSET_LOGO,
    HOSPITAL_CANCELLED_IMAGE_SRC,
    NURSE_CANCELLED_IMAGE_SRC,
} from '@constants/images';
import {
    RESET_PASSWORD_PATH,
    LOGIN_PATH,
    VERIFICATION_PATH,
    HELP_AND_SUPPORT_PATH,
} from '@constants/routes';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import { HOSPITAL, NURSE } from '@constants/constants';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { logout } from '@store/reducers/auth/authReducer';
import { clearLocalStoragePreserveLanguage } from '@utils/utils';

const NotApprovedPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const userRole = useAppSelector((state) => state.login.loggedInUserRole);

    const handleBackClick = () => {
        clearLocalStoragePreserveLanguage();
        dispatch(logout());
        navigate(LOGIN_PATH);
    };

    const support = () => {
        window.open(HELP_AND_SUPPORT_PATH, '_blank');
    };

    return (
        <div className="bg-white w-full min-h-screen over">
            <div className="flex items-center justify-between px-4 py-3">
                {/* <div
                    className="flex items-center cursor-pointer absolute top-0 mt-4 text-lg text-nero font-semibold"
                    onClick={handleBackClick}
                >
                    <FaArrowLeftLong className="mr-2 cursor-pointer" />
                    <span>{t('auth.back')}</span>
                </div> */}
                <div className="flex-grow flex justify-center">
                    <div className="logo-container">
                        <Link to={LOGIN_PATH}>
                            <img
                                src={DRIPSET_LOGO}
                                alt="Dripset_logo"
                                className="object-contain"
                            />
                        </Link>
                    </div>
                </div>
            </div>
            <div className="flex flex-col items-center justify-center mt-5">
                <div className="mx-auto flex justify-center my-5">
                    {userRole.toLowerCase() == HOSPITAL.toLowerCase() && (
                        <img
                            src={HOSPITAL_CANCELLED_IMAGE_SRC}
                            alt="OTP"
                            className="object-contain"
                        />
                    )}
                    {userRole.toLowerCase() == NURSE.toLowerCase() && (
                        <img
                            src={NURSE_CANCELLED_IMAGE_SRC}
                            alt="OTP"
                            className="object-contain"
                        />
                    )}
                </div>
                <div className="text-center">
                    <h3 className="text-2xl font-bold text-black mb-2">
                        {t('auth.not_approved.title')}
                    </h3>
                    <p className="text-grey test-sm font-normal mb-3">
                        {t('auth.not_approved.description')}
                        <br />
                        {userRole.toLowerCase() == HOSPITAL.toLowerCase() && (
                            <>
                                {t('auth.not_approved.description_1')}
                                <br />
                            </>
                        )}
                        {userRole.toLowerCase() == NURSE.toLowerCase() && (
                            <>
                                {t('auth.not_approved.description_nurse')}
                                <br />
                            </>
                        )}
                    </p>
                    {userRole.toLowerCase() == HOSPITAL.toLowerCase() && (
                        <button
                            onClick={support}
                            className="btn w-4/5 mt-2 py-3 px-4 !bg-primary !hover:bg-primary text-white font-semibold rounded-lg"
                        >
                            {t('auth.not_approved.contact_support')}
                        </button>
                    )}
                    <button
                        onClick={handleBackClick}
                        className="btn w-4/5 mt-2 py-3 px-4 !bg-primary !hover:bg-primary text-white font-semibold rounded-lg"
                    >
                        {t('auth.not_approved.back')}
                    </button>
                </div>
            </div>
        </div>
    );
};
export default NotApprovedPage;
